import { DialogContent as MuiDialogContent } from '@material-ui/core';
import { Column, Columns } from '@superdispatch/ui';
import { useMemo } from 'react';
import { useCarrierSettings } from 'shared/settings/CarrierSettingsAPI';
import { useFlag } from 'shared/settings/FeatureToggles';
import styled from 'styled-components';
import { useOnboardingDetails } from '../data/OnboardingAPI';
import { isGettingStartedCompleted } from './isGettingStartedCompleted';
import { OnboardingTasks } from './OnboardingTasks';
import { OnboardingVerificationTasks } from './OnboardingVerificationTasks';

const DialogContent = styled(MuiDialogContent)`
  padding: 60px 88px;
`;

interface OnboardingContentProps {
  onClose: () => void;
}

export function OnboardingContent({ onClose }: OnboardingContentProps) {
  const { data } = useOnboardingDetails();
  const { data: settings } = useCarrierSettings();
  const isSuperCardEnabled = useFlag('supercard_management');

  const isCompleted = useMemo(
    () =>
      isGettingStartedCompleted({
        data,
        verificationStatus: settings?.carrier.verification_status,
        isSuperCardEnabled,
        hasSettings: settings != null,
      }),
    [data, settings, isSuperCardEnabled],
  );

  return (
    <DialogContent>
      <Columns align={isCompleted ? 'center' : 'top'} space="xxlarge">
        <Column width="1/2">
          <OnboardingVerificationTasks
            onClose={onClose}
            onboardingSteps={data}
          />
        </Column>
        <Column width="1/2">
          <OnboardingTasks
            onboardingSteps={data}
            completed={isCompleted}
            onClose={onClose}
          />
        </Column>
      </Columns>
    </DialogContent>
  );
}
